// extracted by mini-css-extract-plugin
export default {"productDescription":"q--z","featuredDescription":"r--z","description":"s--z","more":"t--z","descriptionSku":"u--z"};